<div class="account-personalisation-terms-form">
  <p class="account-personalisation-terms-text ods-typography-body-m-regular account-personalisation-terms-headline">
    {{ 'account_personalisation_terms_text' | translate }}:
  </p>
  <p class="account-personalisation-terms-text ods-typography-body-m-regular">
    {{ 'discounts_coupons_and_offers' | translate }}
  </p>
  <p class="account-personalisation-terms-text ods-typography-body-m-regular">{{ 'new_shops_to_try' | translate }}</p>
  <mat-radio-group class="account-personalisation-terms-radio-group" (change)="onConsentOptionChange($event.value)">
    <mat-radio-button
      *ngFor="let option of consentOptions"
      class="account-personalisation-terms-radio-button"
      color="primary"
      [value]="option.value"
      [checked]="option.value === selectedConsentValue"
    >
      <span class="account-personalisation-terms-text ods-typography-body-m-regular"
        >{{ option.text | translate }}</span
      >
    </mat-radio-button>
  </mat-radio-group>
  <button type="button" box-button theme="primary" (click)="submitConsentOption()" [disabled]="!canSubmit">
    {{ 'save_' | translate }}
  </button>
</div>
<div class="account-personalisation-terms-document">
  <button class="account-personalisation-terms-document-toggle" type="button" (click)="toggleTermsDocument()">
    <span class="account-personalisation-terms-document-toggle-text">{{ 'see_details' | translate }}</span>
    <mat-icon class="account-personalisation-terms-document-toggle-icon" fontSet="material-icons-round">
      {{ termsToggled ? 'expand_less' : 'expand_more' }}
    </mat-icon>
  </button>
  <ng-container *ngIf="termsToggled">
    <div *ngIf="termsLoading; else termsLoaded" class="account-personalisation-terms-document-content">
      <p class="p--skeleton"></p>
      <p class="p--skeleton"></p>
      <p class="p--skeleton"></p>
      <p class="p--skeleton"></p>
      <p class="p--skeleton"></p>
      <br />
      <p class="p--skeleton"></p>
      <p class="p--skeleton"></p>
    </div>
    <ng-template #termsLoaded>
      <div class="account-personalisation-terms-document-content" [innerHTML]="marketingTermsHtml"></div>
    </ng-template>
  </ng-container>
</div>
